// Module
var code = `<div on-click="@this.onClick(event)"
     class="js-combobox{{#if isMenuShown || isGTDFormOpened}} active{{/if}}"
     style="{{>visibility}} {{#if isPosAbsolute}}position: absolute; z-index: {{zIndex}};{{>position}}{{/if}}"
     {{#if !.enabled || (!.items.length && !isAllowEmpty)}} disabled="" {{elseif .focused}} focused="" {{/if}}>

    <div>{{.selectedItemLocalizedText}}</div>

    <div class="js-combobox-arrow-down" {{^.showArrow}} style="display: none;" {{/}}>
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
        </svg>
    </div>
</div>`;
// Exports
export default code;